import { Box, Flex } from '@chakra-ui/react';
import { animate, motion, useMotionValue, useTransform } from 'framer-motion';
import { useEffect } from 'react';
import { Condition } from 'Component/others';

import styles from './styles.module.css';

const ProgressBar = ({ duration = 5, showPercentage = true }) => {
  const count = useMotionValue(0);
  const rounded = useTransform(() => Math.round(count.get()));

  useEffect(() => {
    const controls = animate(count, 95, { duration: duration });
    return () => controls.stop();
  }, [count, duration]);

  return (
    <Flex className={styles['progress-bar__container']} width={'100%'} alignItems={'center'} gap={'8px'}>
      <Box flex={1}>
        <motion.div className={styles['progress-bar__progress-container']}>
          <motion.div animate={{ width: '95%' }} transition={{ duration }} className={`${styles['progress-bar__progress-fill-track']}`} />
        </motion.div>
      </Box>

      <Condition statement={showPercentage}>
        <Box width={'7%'} textAlign={'right'}>
          <span className={styles['progress-bar__value-percentage']}>
            <motion.pre className={styles['progress-bar__value-percentage']}>{rounded}</motion.pre>%
          </span>
        </Box>
      </Condition>
    </Flex>
  );
};

export default ProgressBar;
